var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.1564 18.2666L7.1004 34.5126C6.35137 35.3774 5.95784 36.4939 5.99903 37.6373C6.04022 38.7806 6.51308 39.8659 7.3224 40.6746C8.13108 41.4839 9.21636 41.9568 10.3597 41.998C11.5031 42.0392 12.6196 41.6456 13.4844 40.8966L29.7304 26.8406L21.1564 18.2666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.901 31.5883C17.6045 31.588 17.3148 31.4999 17.0684 31.3351C16.8219 31.1702 16.6299 30.9361 16.5165 30.6621C16.403 30.3882 16.3733 30.0868 16.4311 29.796C16.4889 29.5052 16.6315 29.2381 16.841 29.0283L18.827 27.0423C19.1117 26.776 19.4887 26.6308 19.8785 26.6374C20.2682 26.644 20.6402 26.8019 20.9157 27.0776C21.1912 27.3534 21.3487 27.7255 21.3549 28.1152C21.3611 28.505 21.2156 28.8819 20.949 29.1663L18.961 31.1503C18.8219 31.2895 18.6566 31.3999 18.4747 31.4751C18.2928 31.5502 18.0979 31.5887 17.901 31.5883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6287 21.5123L26.4847 8.36831C27.3376 7.56981 28.3428 6.95153 29.4401 6.55045C30.5374 6.14937 31.7043 5.97374 32.8711 6.03404C34.0379 6.09435 35.1805 6.38937 36.2306 6.90144C37.2807 7.41352 38.2168 8.13213 38.9827 9.01431C39.8649 9.7803 40.5835 10.7163 41.0956 11.7665C41.6077 12.8166 41.9027 13.9592 41.963 15.126C42.0233 16.2927 41.8477 17.4597 41.4466 18.557C41.0455 19.6543 40.4272 20.6594 39.6287 21.5123ZM23.8587 10.8803C22.7922 11.7636 21.9787 12.9137 21.5009 14.2135C21.0231 15.5133 20.8982 16.9165 21.1387 18.2803L29.7127 26.8543C31.0765 27.0949 32.4797 26.9699 33.7795 26.4922C35.0793 26.0144 36.2294 25.2009 37.1127 24.1343L37.5607 23.6863L24.3067 10.4323L23.8587 10.8803Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.6306 21.5117L26.4866 8.36768C26.2326 8.58168 25.9686 8.76768 25.7266 9.01368L24.3086 10.4317L37.5666 23.6897L38.9846 22.2717C39.2286 22.0297 39.4166 21.7657 39.6306 21.5117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.fbdc2d86f9d3c64270f344259207b248.svg";
export { ForwardRef as ReactComponent };